module.exports = __webpack_public_path__ + "img/ma.7276e49b.svg";